import { isset } from 'src/util/Util.js';

const mixinValidate = {
  methods: {
    validate() {
      const associationValidate = !isset(this.model.association_ids);
      if (this.isRequiredAssociations && associationValidate) {
        return this.validationInputsRequired('associations');
      }

      const businessValidate = !isset(this.model.businesses_ids);
      if (this.isRequiredBusinesses && businessValidate) {
        return this.validationInputsRequired('businesses');
      }

      const zoneValidate = !isset(this.model.zone_ids);
      if (this.isRequiredZones && zoneValidate) {
        return this.validationInputsRequired('zones');
      }

      const subZoneValidate = !isset(this.model.subzone_ids);
      if (this.isRequiredSubZones && subZoneValidate) {
        return this.validationInputsRequired('subzones');
      }

      const cropTypesValidate = !isset(this.model.croptypes_ids);
      if (this.isRequiredCropTypes && cropTypesValidate) {
        return this.validationInputsRequired('croptypes');
      }

      const cropsValidate = !isset(this.model.crops_ids);
      if (this.isRequiredCrops && cropsValidate) {
        return this.validationInputsRequired('crops');
      }

      const calendarValidate =
        this.isShowCalendar && !isset(this.model.calendar_sel);
      if (calendarValidate) {
        return this.validationInputsRequired('calendar');
      }

      const farmsValidate = !isset(this.model.farm_ids);
      if (this.isRequiredFarms && farmsValidate) {
        return this.validationInputsRequired('farm');
      }

      const lotsValidate = !isset(this.model.lot_ids);
      if (this.isRequiredLots && lotsValidate) {
        return this.validationInputsRequired('lot');
      }

      const ribbonsValidate = !isset(this.model.ribbons_id);
      if (this.isRequiredRibbons && ribbonsValidate) {
        return this.validationInputsRequired('ribbons');
      }

      const usersValidate = !isset(this.model.users_ids);
      if (this.isRequiredUsers && usersValidate) {
        return this.validationInputsRequired('users');
      }

      const workersValidate = !isset(this.model.workers_ids);
      if (this.isRequiredWorkers && workersValidate) {
        return this.validationInputsRequired('workers');
      }

      const bySelValidate = !isset(this.model.bySel);
      if (bySelValidate) {
        return this.validationInputsRequired('time');
      }

      let yearValidate =
        (this.model.bySel == 'Año' &&
          (!isset(this.model.year_sel_init) ||
            !isset(this.model.year_sel_end))) ||
        (this.model.bySel == 'Semana' &&
          this.isYearSelRequired() &&
          !isset(this.model.year_sel_init));
      if (yearValidate) {
        return this.validationInputsRequired('year');
      }

      yearValidate =
        this.model.comparate &&
        ((this.model.bySel == 'Año' &&
          (!isset(this.model.comp_year_sel_init) ||
            !isset(this.model.comp_year_sel_end))) ||
          (this.model.bySel == 'Semana' &&
            this.isYearSelRequired() &&
            !isset(this.model.comp_year_sel_init)));
      if (yearValidate) {
        return this.validationInputsRequired('comp-year');
      }

      let weekValidate =
        this.isWeekSekRequired() &&
        !isset(this.model.week_sel_init) &&
        this.model.bySel == 'Semana';
      if (weekValidate) {
        return this.validationInputsRequired('week');
      }

      weekValidate =
        this.model.comparate &&
        this.isWeekSekRequired() &&
        !isset(this.model.comp_week_sel_init) &&
        this.model.bySel == 'Semana';
      if (weekValidate) {
        return this.validationInputsRequired('comp-week');
      }

      weekValidate =
        this.isYearSelRequired() &&
        !isset(this.model.year_sel_end) &&
        this.model.bySel == 'Semana';
      if (weekValidate) {
        return this.validationInputsRequired('year');
      }

      weekValidate =
        this.model.comparate &&
        this.isYearSelRequired() &&
        !isset(this.model.comp_year_sel_end) &&
        this.model.bySel == 'Semana';
      if (weekValidate) {
        return this.validationInputsRequired('comp-year');
      }

      weekValidate =
        this.isWeekSekRequired() &&
        !isset(this.model.week_sel_end) &&
        this.model.bySel == 'Semana';
      if (weekValidate) {
        return this.validationInputsRequired('week');
      }

      weekValidate =
        this.model.comparate &&
        this.isWeekSekRequired() &&
        !isset(this.model.comp_week_sel_end) &&
        this.model.bySel == 'Semana';
      if (weekValidate) {
        return this.validationInputsRequired('comp-week');
      }

      if (!isset(this.rangeDate)) {
        return this.validationInputsRequired('year');
      }

      if (this.model.comparate && !isset(this.rangeDateComparate)) {
        return this.validationInputsRequired('year-comparate');
      }

      this.$emit('filter', this.loadData());
    },
  },
};

export default mixinValidate;
